import {ApiError} from '@mintdata-wsp/common/controllers/network/Fetcher';
import {PublishedApplicationResponse} from '@mintdata-wsp/common/controllers/network/generated/responses/PublishedApplicationResponse';
import {PublishedDesignsResponse} from '@mintdata-wsp/common/controllers/network/generated/responses/PublishedDesignsResponse';
import {AnalyticsEventActions} from '@mintdata-wsp/common/controllers/analytics/AnalyticsEventActions';
import {API} from '@mintdata-wsp/common/controllers/network/WorkspaceAPI';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import bind from 'bind-decorator';
import {action} from 'mobx';

export class PublishedAppsController
{
    @bind
    public init(fromPublishedAppsPage:boolean = false):Promise<any>
    {
        // commonControllers.analytics.main.initAllVendors();

        // controllers.data.organizations.syncAllOrganizations();
        return this._syncPublishedApps(fromPublishedAppsPage);
    }

    private async _syncPublishedApps(fromPublishedAppsPage:boolean = false):Promise<any>
    {
        return API.publish.listPublished()
            .then(action((response:PublishedDesignsResponse | ApiError) =>
            {
                if( ApiError.isError(response) )
                {
                    throw (response as ApiError).message;
                }

                rootState.data.publishedApps = (response as PublishedDesignsResponse).designs;

                // if ((response as PublishedDesignsResponse).designs.length)
                // {
                //     rootState.ui.publishedApps.list = (response as PublishedDesignsResponse).designs;
                // }
                // else
                // {
                //     // TODO remove tests
                //
                //     rootState.ui.publishedApps.list = [
                //         {
                //             designId: 1,
                //             designName: 'designName and long name long name',
                //             designDescription: '11 Some long designDescription for test 22 Some long designDescription for test 33 Some long designDescription for test',
                //             projectId: 11,
                //             projectName: 'Adobe Systems',
                //             versions: [
                //             {
                //                 id: 2,
                //                 version: 'BETA',
                //                 urlPart: 'urlPart',
                //                 sharingMode: 'sharingMode',
                //                 status: 'RUNNING',
                //                 error: 'error',
                //             },
                //             ]
                //         },
                //         {
                //             designId: 4,
                //             designName: 'designName',
                //             designDescription: '',
                //             projectId: 12,
                //             projectName: 'Mintdata',
                //             versions: [
                //             {
                //                 id: 5,
                //                 version: 'BETA',
                //                 urlPart: 'urlPart',
                //                 sharingMode: 'sharingMode',
                //                 status: 'STOPPING',
                //                 error: 'error',
                //             },
                //             {
                //                 id: 6,
                //                 version: 'MAIN',
                //                 urlPart: 'urlPart',
                //                 sharingMode: 'sharingMode',
                //                 status: 'RUNNING',
                //                 error: 'error',
                //             },
                //             ]
                //         },
                //         {
                //             designId: 7,
                //             designName: 'designName and',
                //             designDescription: 'designDescription for test',
                //             projectId: 11,
                //             projectName: 'Adobe Systems',
                //             versions: [
                //             {
                //                 id: 8,
                //                 version: 'MAIN',
                //                 urlPart: 'urlPart',
                //                 sharingMode: 'sharingMode',
                //                 status: 'DEPLOYING_TOPOLOGY',
                //                 error: 'error',
                //             },
                //             ]
                //         },
                //     ]
                // }
                controllers.ui.anyPage.disablePageLoader();

                if( fromPublishedAppsPage )
                    controllers.analytics.main.trackEvent(AnalyticsEventActions.WSP_PAGE_LOADED);
            }))
            .catch(err =>
            {
                console.warn(err);
                controllers.ui.anyPage.disablePageLoader();

                if( fromPublishedAppsPage )
                    controllers.analytics.main.trackEvent(AnalyticsEventActions.WSP_PAGE_LOADED);
            });
    }

    @bind
    public unpublish(publishedApplicationId:number)
    {
        API.publish.unpublish(publishedApplicationId)
            .then((response:PublishedApplicationResponse | ApiError) =>
            {
                if( ApiError.isError(response) )
                {
                    throw (response as ApiError).message;
                }

                this._syncPublishedApps();
            })
            .catch(err =>
            {
                console.warn(err);
            });
    }
}
